import { selectUser } from 'oidc/user.selectors';
import { Authorized } from 'oidc/userHelper';
import { userRoles } from 'oidc/userRoles';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import JobPreferencesModal from '../JobPreferencesModal';
import { jobPreferncesActions } from '../store/JobPreferences.redux';

const EditJobPreferences = props => {
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const { displayText, id } = props;
  const user = useSelector(selectUser);

  const stopImmediatePropagation = event => {
    event.stopPropagation();
    event.preventDefault();
  };

  const openModal = e => {
    if (
      Authorized(
        [userRoles.recruitment_TeamMember, userRoles.recruitment_Leadership],
        user.userInfo,
      )
    ) {
      stopImmediatePropagation(e);
      dispatch(jobPreferncesActions.setModalProps(id));
      setOpen(true);
    }
  };

  return (
    <div>
      <p
        style={{ color: '#0D76BC', fontSize: '14px' }}
        onClick={e => {
          openModal(e);
        }}
      >
        {displayText}
      </p>
      <JobPreferencesModal open={open} title={'Edit Preference'} onClose={() => setOpen(false)} />
    </div>
  );
};

export default EditJobPreferences;
